export default "__VITE_ASSET__CieRXJPm__"